/* eslint camelcase: 0 */

import { Formdata as Data } from '@/typings/api/Formdata'
import { Model, createMessages } from '@/helpers/Model'


export class FormDataModel extends Model<Data> {
    public static readonly page_title = createMessages({
      create: 'Добавить форму сбора данных',
      edit: 'Редактировать форму сбора данных',
      view: (data: FormDataModel) => 'Форма «{name}»'
        .replace('{name}', data.name || '...'),
      list: 'ФСД',
    });

    public static readonly modal_delete = createMessages({
      ...Model.modal_delete,
      delete: (data: FormDataModel) => 'Удаление формы «{name}»'
        .replace('{name}', data.name || '...'),
    });
}
